"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 10px;\n  display: flex;\n  align-items: center;\n\n  .star {\n    cursor: pointer;\n    font-size: 12px;\n    color: #d9d9d9;\n    transition: color 0.3s;\n    line-height: 10px;\n\n    &:hover {\n      color: gold;\n    }\n\n    &.active {\n      transform: scale(1.2);\n      color: #8a6caa;\n    }\n\n    &:not(:first-child) {\n      margin-left: 5px;\n    }\n  }\n"])));

exports.Container = Container;